import type { CampaignFilters } from '@crm/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export const CONTACT_LISTS_ROUTES = {
  LIST: '/marketing/listas-de-contatos',
} as const;

const ENDPOINT = '/api/v1/contact-lists';
const KEY = ['contact-lists'];

export interface ContactList {
  id: string;
  name: string;
  filters: CampaignFilters;
  /** Quantas pessoas o criterio alcanca agora - a lista nao guarda gente. */
  total: number;
  createdAt: string;
}

export interface ContactListInput {
  name: string;
  filters: CampaignFilters;
}

export function useContactLists() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => apiClient.get<{ data: ContactList[] }>(ENDPOINT),
  });
}

/** Toda mutacao invalida a lista - o total de cada uma vem do servidor. */
function useContactListMutation<TArgs, TResult>(mutationFn: (args: TArgs) => Promise<TResult>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useCreateContactList() {
  return useContactListMutation((input: ContactListInput) =>
    apiClient.post<ContactList>(ENDPOINT, input),
  );
}

export function useUpdateContactList() {
  return useContactListMutation(({ id, input }: { id: string; input: Partial<ContactListInput> }) =>
    apiClient.patch<ContactList>(`${ENDPOINT}/${id}`, input),
  );
}

export function useDeleteContactList() {
  return useContactListMutation((id: string) => apiClient.delete<void>(`${ENDPOINT}/${id}`));
}
